import { useQuery } from "@tanstack/react-query";
import { GAS_PRICE_CACHE_KEY, GAS_PRICE_REFRESH_INTERVAL } from "@/config";
import { formatUnits } from "viem";
import { usePublicClient } from "wagmi";

const GWEI_DECIMALS = 9;

export function useGasPrice() {
    const publicClient = usePublicClient();

    return useQuery({
        queryKey: [GAS_PRICE_CACHE_KEY],
        queryFn: async () => {
            if (!publicClient) return null;
            const gasPrice = await publicClient.getGasPrice();
            const formattedGas = formatUnits(gasPrice, GWEI_DECIMALS);
            return Number(formattedGas);
        },
        refetchInterval: GAS_PRICE_REFRESH_INTERVAL,
    });
}
